module.exports = __webpack_public_path__ + "static/media/entrega.f856d3b3.jpg";